import $ from 'jquery';

let translations = {};

$('#js-translations *[data-key][data-value]').each(function (i, elem) {
    let $elem = $(elem);
    translations[$elem.data('key')] = $elem.data('value');
});

// replace %s with arguments
export default function _(key, ...args) {
    let translation = translations[key];
    if (translation === undefined) {
        return key;
    }
    if (args.length === 0) {
        return translation;
    }
    return translation.replace(/%s/g, () => args.shift());
}
